import { GRAY_COLORS } from 'asterX-UI/colors.constant'

export const styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    margin: '0 auto',
    width: 'fit-content',
    border: `1px solid ${GRAY_COLORS[200]}`,
    borderRadius: 8
  },
  /* Styles applied to the ul element. */
  ul: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none',
    '& .MuiPaginationItem-root': {
      height: 48,
      borderRadius: 0,
      display: 'flex',
      alignItems: 'center',
      margin: 0
    }
  },
  divider: {
    height: 2,
    backgroundColor: GRAY_COLORS[200],
    marginBottom: 20
  },
  previousButton: {
    padding: '10px 16px'
  },
  nextButton: {
    padding: '10px 16px'
  },
  countPages: {
    color: GRAY_COLORS[700],
    fontSize: 14,
    fontWeight: 400
  }
}
